export class StockSymbol {
    
    id: number;

    code: String;

    name: String;

}
